import React, { useEffect, useState } from "react";
import icon1 from "../../images/icons/icon_calendar.svg";
import icon2 from "../../images/icons/icon_user.svg";
import icon5 from "../../images/icons/icon_link.svg";
import icon6 from "../../images/icons/icon_bookmark.svg";

import sImg1 from "../../images/icons/icon_facebook.svg";
import sImg2 from "../../images/icons/icon_twitter_x.svg";
import sImg3 from "../../images/icons/icon_linkedin.svg";
import sImg4 from "../../images/icons/icon_instagram.svg";

import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import BlogSidebar from "../BlogSidebar";
import axios from "axios";

const formatDMY = (value) => {
  const d = new Date(value);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};
const stripHtml = (html) => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  const text = div.textContent || div.innerText || "";
  return text.replace(/\s+/g, " ").trim();
};

const truncate = (text, limit = 100) => {
  if (!text) return "";
  if (text.length <= limit) return text;
  const sliced = text.slice(0, limit);
  const lastSpace = sliced.lastIndexOf(" ");
  return (
    (lastSpace > Math.floor(limit * 0.8)
      ? sliced.slice(0, lastSpace)
      : sliced) + "..."
  );
};

const BlogSingle = () => {
  const { id } = useParams();
  const decodedTitle = encodeURIComponent(id.replace(/-/g, " "));
  const [blogData, setBlogData] = useState([]);
  const [copied, setCopied] = useState(false);
  const [shareError, setShareError] = useState("");

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `https://api.rashtechinfo.com/getBlogById/${decodedTitle}`
        );

        const data = response.data;
        setBlogData(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchBlog();
  }, [id]);

  const getShareUrl = () => {
    // Prefer canonical link if you have one; else fallback to current location
    try {
      return window.location.href;
    } catch {
      return "";
    }
  };

  const getShareTitle = () => blogData?.blog_title || "Check this out";
  const getShareText = () =>
    `Reading: ${blogData?.blog_title || "this post"} from RashTech Info`;

  const copyLink = async () => {
    const url = getShareUrl();
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setShareError("");
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      setShareError("Unable to copy the link. Please copy manually.");
    }
  };

  const shareNative = async () => {
    const url = getShareUrl();
    const title = getShareTitle();
    const text = getShareText();

    // Use Web Share API if available
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        setShareError("");
      } catch (err) {
        // If user cancels, do nothing; if error, try fallback
        if (err?.name !== "AbortError") {
          copyLink();
        }
      }
    } else {
      // Fallback to copy
      copyLink();
    }
  };

  const encodedUrl = encodeURIComponent(getShareUrl());
  const encodedTitle = encodeURIComponent(getShareTitle());

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="blog_details_section section_space bg-light">
      <div className="container">
        <div className="details_item_image">
          <img
            src={`https://api.rashtechinfo.com/images/blogs/${blogData.blog_image}`}
            alt="RashTech - Blog"
            style={{ width: "100%", contain: "cover", borderRadius: "50px" }}
          />
        </div>
        <div className="post_meta_wrap mb-4">
          <ul className="category_btns_group unordered_list">
            <li>
              <Link onClick={ClickHandler} to={"/blog"}>
                {blogData.category}
              </Link>
            </li>
          </ul>
          <ul className="post_meta unordered_list">
            <li>
              <Link onClick={ClickHandler} to={"/blog"}>
                <img src={icon1} alt="Icon Calendar" />{" "}
                {formatDMY(blogData.createdAt)}
              </Link>
            </li>
          </ul>
        </div>
        <h2 className="details_item_title">{blogData.blog_title}</h2>
        <p>
          Explore the future of IT with RashTech Info’s thought leaders. From
          AI-driven automation and resilient cloud architectures to
          privacy-first design and analytics at scale, we share pragmatic
          perspectives grounded in delivery. Our mission is simple: transform
          complex challenges into elegant, scalable solutions that create
          lasting value.
        </p>
        <div className="row align-items-center">
          <div className="col-md-6">
            <ul className="post_meta unordered_list">
              <li>
                <Link onClick={ClickHandler} to={"/blog"}>
                  <img src={icon2} alt="Icon User" /> by {blogData.authorName}
                </Link>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul className="post_meta unordered_list justify-content-md-end">
              <li>
                <button
                  type="button"
                  onClick={copyLink}
                  aria-label="Copy link"
                  title="Copy link"
                >
                  <img src={icon5} alt="Icon Link" />{" "}
                  <span className="ms-1">Copy Link</span>
                </button>
                {copied && (
                  <span
                    className="ms-2 text-success"
                    role="status"
                    aria-live="polite"
                  >
                    Link copied!
                  </span>
                )}
              </li>
              <li>
                <button
                  type="button"
                  onClick={shareNative}
                  aria-label="Share"
                  title="Share"
                >
                  <img src={icon6} alt="Bookmark Share" />{" "}
                  <span className="ms-1">Share</span>
                </button>
                {shareError && (
                  <span className="ms-2 text-danger" role="alert">
                    {shareError}
                  </span>
                )}
              </li>
            </ul>
          </div>
        </div>
        <hr className="mb-0" />
        <div className="section_space pb-0">
          <div className="row">
            <div className="col-lg-8">
              <h3 className="details_item_info_title mb-5">
                {truncate(stripHtml(blogData.blog_content), 100)}
              </h3>
              <div
                className="blog-content prose"
                dangerouslySetInnerHTML={{ __html: blogData.blog_content }}
              />
              <hr className="mt-0 mb-5" />
              <div className="row">
                <div className="col-md-6">
                  <ul className="tags_list unordered_list">
                    {Array.isArray(blogData?.tags) &&
                    blogData.tags.length > 0 ? (
                      blogData.tags.map((tag) => (
                        <li key={tag}>
                          <Link
                            onClick={ClickHandler}
                            to={`/blog/${blogData.blog_title.replace(/\s+/g, "-")}`}
                          >
                            {tag}
                          </Link>
                        </li>
                      ))
                    ) : (
                      <li>
                        <Link onClick={ClickHandler} to="/blog">
                          No tags
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>

                <div className="col-md-6">
                  <div className="post_share_link">
                    <ul className="social_icons_block unordered_list justify-content-md-end">
                      <li>
  <a
    href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
    target="_blank"
    rel="noopener noreferrer"
    className="rounded-circle"
    aria-label="Share on Facebook"
    title="Share on Facebook"
  >
    <img src={sImg1} alt="Icon Facebook" />
  </a>
</li>
<li>
  <a
    href={`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`}
    target="_blank"
    rel="noopener noreferrer"
    className="rounded-circle"
    aria-label="Share on X"
    title="Share on X"
  >
    <img src={sImg2} alt="Icon Twitter X" />
  </a>
</li>
<li>
  <a
    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
    target="_blank"
    rel="noopener noreferrer"
    className="rounded-circle"
    aria-label="Share on LinkedIn"
    title="Share on LinkedIn"
  >
    <img src={sImg3} alt="Icon Linkedin" />
  </a>
</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <BlogSidebar />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogSingle;
